var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconGraduation48Line = function SvgIconGraduation48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7 19.33c0-1.16-.66-2.18-1.72-2.65l-13.8-6.13c-.75-.33-1.61-.33-2.35 0l-13.8 6.13a2.868 2.868 0 0 0-1.72 2.65c0 1.16.66 2.18 1.72 2.65l3.78 1.68v8.2c0 .67.39 1.28 1.01 1.55l9.01 4.03a2.923 2.923 0 0 0 2.37 0l9.01-4.03a1.7 1.7 0 0 0 1.01-1.55v-8.2l2.1-.93v8.6h3.4v-12h-.02Zm-8.9 11.43L24 34.25l-7.8-3.49v-5.59l6.62 2.94c.38.17.78.25 1.18.25.4 0 .8-.08 1.18-.25l6.62-2.94v5.59ZM24 24.91l-12.57-5.58L24 13.75l12.57 5.58L24 24.91Z",
    fill: "current"
  })));
};
export default SvgIconGraduation48Line;